import { TypographyOptions } from "@mui/material/styles/createTypography";
import { pxToRem } from "./utils/formatFontSize";

const FONT_PRIMARY = "Inter";
const Typography: TypographyOptions = {
  fontFamily: FONT_PRIMARY,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,

  h1: {
    color: "inherit",
    fontWeight: 700,
    fontSize: pxToRem(32),
    lineHeight:  pxToRem(40),
    textTransform: "none",
  },
  h2: {
    color: "inherit",
    fontWeight: 700,
    fontSize: pxToRem(24),
    lineHeight: pxToRem(32),
    textTransform: "none",
  },
  h3: {
    color: "inherit",
    fontWeight: 700,
    fontSize: pxToRem(22),
    lineHeight: pxToRem(30),
    textTransform: "none",
  },
  h4: {
    color: "inherit",
    fontWeight: 500,
    fontSize: pxToRem(18),
    lineHeight: pxToRem(26),
    textTransform: "none",
  },
  // paragraph
  h5: {
    color: "inherit",
    fontWeight: 400,
    fontSize: pxToRem(18),
    lineHeight: pxToRem(26),
    textTransform: "none",
  },
  body1: {
    color: "inherit",
    fontWeight: 500,
    fontSize: pxToRem(16),
    lineHeight: pxToRem(24),
    textTransform: "none",
  },
  body2: {
    color: "inherit",
    fontWeight: 400,
    fontSize: pxToRem(16),
    lineHeight: pxToRem(24),
    textTransform: "none",
  },
  button: {
    color: "inherit",
    fontWeight: 500,
    fontSize: pxToRem(16),
    lineHeight: pxToRem(24),
    textTransform: "none",
  },
  subtitle1: {
    color: "inherit",
    fontWeight: 400,
    fontSize: pxToRem(14),
    lineHeight: pxToRem(22),
    textTransform: "none",
  },
  subtitle2: {
    color: "inherit",
    fontWeight: 500,
    fontSize: pxToRem(14),
    lineHeight: pxToRem(22),
    textTransform: "none",
  },
  overline: {
    color: "inherit",
    fontSize: pxToRem(12),
    lineHeight: pxToRem(20),
    fontWeight: 400,
    textTransform: "none",
  },
  caption: {
    color: "inherit",
    fontWeight: 400,
    fontSize: pxToRem(14),
    lineHeight: pxToRem(20),
    textTransform: "none",
  },
};

export default Typography;
